import { hide as nativeHide, type Middleware } from '@floating-ui/react-dom';

const nativeHideFn = nativeHide().fn;

export const hide: Middleware = {
  name: 'hide',
  async fn(state) {
    const { width, height, x, y } = state.rects.reference;
    const anchorHidden = width === 0 && height === 0 && x === 0 && y === 0;
    const nativeHideResult = await nativeHideFn(state);
    return {
      data: {
        referenceHidden: nativeHideResult.data?.referenceHidden || anchorHidden,
      },
    };
  },
};
